import React from 'react';
import './StatusBadge.css';

/**
 * StatusBadge component for displaying campaign status with consistent styling
 * Handles enum value mapping and display text formatting
 */
const StatusBadge = ({ status, className = '' }) => {
  // Map enum values to display text
  const getDisplayText = (status) => {
    switch (status) {
      case 'awaiting_creatives':
        return 'Awaiting Creatives';
      case 'ready_to_launch':
        return 'Ready to Launch';
      case 'awaiting_download':
        return 'Awaiting Download';
      case 'completed_with_errors':
        return 'Completed with Errors';
      case 'import_failed':
        return 'Import Failed';
      case 'live':
        return 'Live'; // Keep for backward compatibility during migration
      // Retry states for manual pacing
      case 'retrying_import':
        return 'Retrying Import';
      case 'retrying_edit':
        return 'Retrying Edit';
      // Retry states for auto pacing
      case 'retrying_refresh':
        return 'Retrying Refresh';
      // Revert states
      case 'reverting':
        return 'Reverting';
      case 'reverted':
        return 'Reverted';
      case 'revert_failed':
        return 'Revert Failed';
      case 'ready':
        return 'Ready';
      default:
        return (status || 'Draft').charAt(0).toUpperCase() + (status || 'Draft').slice(1);
    }
  };

  return (
    <span className={`status-badge ${status || 'draft'} ${className}`}>
      {getDisplayText(status)}
    </span>
  );
};

export default StatusBadge;
